
import { useLanguage } from "@/contexts/LanguageContext";
import StepContainer from "../components/StepContainer";
import CompanyInfoForm from "../CompanyInfoForm";
import { CampaignFormData } from "../types";
import { useEffect, ReactNode } from "react";
import { useStepValidation } from "../hooks/useStepValidation";

interface InformationStepProps {
  formData: CampaignFormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onNext: () => void;
  onBack?: () => void;
  aiAssistantButton?: ReactNode;
}

const InformationStep = ({ formData, onChange, onNext, onBack, aiAssistantButton }: InformationStepProps) => {
  const { t } = useLanguage();
  const { isInformationStepValid } = useStepValidation();

  // Real-time validation
  const isNextDisabled = !isInformationStepValid(formData);

  // Store form data to localStorage whenever it changes
  useEffect(() => {
    if (formData) {
      // Save under multiple keys for backward compatibility
      localStorage.setItem('formData', JSON.stringify(formData));
      localStorage.setItem('companyInfo', JSON.stringify(formData));
      
      // Also save with a more specific name for the invoice generator
      localStorage.setItem('companyDetails', JSON.stringify(formData));
    }
  }, [formData]);

  return (
    <StepContainer
      title={t("information")}
      description={t("enterAccountInfoDesc")}
      onNext={onNext}
      onBack={onBack}
      isBackDisabled={!onBack}
      isNextDisabled={isNextDisabled}
      aiAssistantButton={aiAssistantButton}
    >
      <CompanyInfoForm formData={formData} onChange={onChange} />
    </StepContainer>
  );
};

export default InformationStep;
